import ModalSidebar from 'components/modals/sidebar/ModalSidebar';
import ModalSidebarHeader from 'components/modals/sidebar/ModalSidebarHeader';
import React from 'react';
import { useTranslator } from '@bluebeam/react-i18n';

interface Props {
  primaryBtnText: string;
  onPrimaryBtnClick: () => void;
}

const ActionsSidebar: React.FC<Props> = (props: Props) => {
  const { primaryBtnText, onPrimaryBtnClick } = props;
  const { translate } = useTranslator(['submittalsPage']);

  return (
    <ModalSidebar id="sub-viewer-modal-action-sidebar">
      <ModalSidebarHeader title={translate('submittalsPage:actions')} />
      <div className="column p4">
        <button
          id="sub-viewer-modal-action-sidebar-action-1-btn"
          className="btn btn-outline-primary mb4"
          onClick={onPrimaryBtnClick}
        >
          {primaryBtnText}
        </button>
      </div>
    </ModalSidebar>
  );
};

export default ActionsSidebar;
